import { Translatable } from '@icc/shared/helpers';

/** Lamela */
export class Lamella {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Obrót lameli */
    rotation?: 90 | 180;
    /** Czy obrót został zmieniony przez użytkownika */
    rotationChanged?: boolean;
    /** Nazwa */
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Opis */
    description: string;
    /** Zdjęcie */
    img: string;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Dostępny obrót 180°  */
    fullRotation: boolean;
    /** Ograniczenia wymiarowe */
    ranges: {
        /** Minimalna szerokość [mm] */
        min_width: number;
        /** Maksymalna wysokość [mm] */
        max_height: number;
        /** Rozmiar pakietu [mm] */
        packet_size: number;
    }[];
    /** Głębokość konstrukcyjna [mm] */
    constructionDepth: number;
    /** Położenie osi otworu dla linki od krawędzi [mm] */
    holeAxisDistance: number;
    /** Szerokość otworu na linkę [mm] */
    holeAxisWidth: number;
    /** Korekta na wymiar technologiczny na stronę dla prowadnic [mm] */
    guidanceAdjustmentForSide: number;
    /** Dodaj jedną lamelę poniżej wysokości [mm] */
    add1BelowHeightMm: number;
    /** Odstęp pomiędzy lamelami [mm] */
    distanceBetweenMm: number;
    /** Korekta na wysokość lameli [mm] */
    lamellaHeightAdjustmentMm: number;
    /** Domyślny uchwyt prowadzenia */
    defaultGuideHandleId: number | null;
    /** Zestaw grup kolorów */
    colorGroupSetId: number;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
}

export interface IccLamella {
    id: number;
    extId: string;
    indexNo: string;
    name: string;
    description: string;
    img: string;
    shutterTypesIds: number[];
    fullRotation: boolean | null;
    ranges: {
        min_width: number;
        max_height: number;
        packet_size: number;
    }[];
    constructionDepth: number;
    holeAxisDistance: number;
    holeAxisWidth: number;
    guidanceAdjustmentForSide: number;
    add1BelowHeightMm: number;
    distanceBetweenMm: number;
    lamellaHeightAdjustmentMm: number;
    defaultGuideHandleId: number | null;
    colorGroupSetId: number;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
}